import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IConclusion, Project} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectGeneral = api.injectEndpoints({
  endpoints: builder => ({
    getProjectGeneral: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/generale`,
        };
      },
      // @ts-expect-error
      providesTags: result => {
        if (result) {
          return [{type: 'projects', id: result.data.id}];
        }
        return [];
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Project>;

export const {useGetProjectGeneralQuery} = getProjectGeneral;
export const selectProjectGeneral =
  getProjectGeneral.endpoints.getProjectGeneral.select;
